import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

const chars = " ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const startCharactersInterval = 750;
const endCharactersInterval = 300;
const speedLerpTime = 3000;

aframe.registerComponent("choose-character-button", {
  schema: {
    direction: { oneOf: ["Ascending", "Descending"], default: "Ascending" }
  },
  init() {
    this.charEl = this.el.parentEl.querySelector("[text__character]");
    this.isPressed = false;
    this.characterTimer = 0;
    this.lerpTimer = 0;
    this.soundEl = document.querySelector("#enterName");
  },
  tick(t, dt) {
    if (!this.isPressed) {
      return;
    }
    this.characterTimer += dt;
    this.lerpTimer += dt;
    const lerpedInterval = Math.max(
      startCharactersInterval +
        (endCharactersInterval - startCharactersInterval) *
          (this.lerpTimer / speedLerpTime),
      endCharactersInterval
    );
    if (this.characterTimer >= lerpedInterval) {
      this.nextCharacter();
      this.characterTimer = 0;
    }
  },
  vrbuttondown: bindEvent(function() {
    this.isPressed = true;
    this.characterTimer = 0;
    this.lerpTimer = 0;
    this.nextCharacter();
  }),
  vrbuttonup: bindEvent(function() {
    this.isPressed = false;
  }),
  nextCharacter() {
    const currentCharacter = this.charEl
      .getAttribute("text__character")
      .value.toUpperCase();
    const currentIndex = chars.indexOf(currentCharacter);
    let nextIndex =
      this.data.direction === "Ascending" ? currentIndex + 1 : currentIndex - 1;
    if (nextIndex < 0) {
      nextIndex = chars.length - 1;
    } else if (nextIndex >= chars.length) {
      nextIndex = 0;
    }
    const nextChar = chars[nextIndex];
    this.charEl.setAttribute("text__character", "value", nextChar);
    this.soundEl.components.misound__changecharacter.playSound();
  }
});
